require('./consumer-complaints.route');
require('./consumer-complaint-detail.controller');